import { Navigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "./AuthContext";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="h-10 w-10 rounded-full border-2 border-[#E20074] border-t-transparent animate-spin" />
    </div>
  );
}

function AccessDenied() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white px-5 font-body" data-testid="access-denied">
      <div className="max-w-md text-center">
        <div className="mx-auto h-16 w-16 rounded-full bg-[#E20074] flex items-center justify-center mb-6">
          <ShieldAlert size={30} />
        </div>
        <h1 className="font-display font-black text-3xl tracking-tight mb-2">Acesso restrito</h1>
        <p className="text-[#a3a3a3] mb-6">
          A sua conta ({user?.email}) não tem permissões de administrador para aceder à área de gestão.
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={logout}
            data-testid="access-denied-logout"
            className="bg-[#1e1e1e] hover:bg-[#E20074] transition-colors px-5 py-2.5 rounded-full text-sm"
          >
            Terminar sessão
          </button>
          <a href="/" className="text-[#a3a3a3] text-sm hover:text-white transition-colors">← Voltar ao site</a>
        </div>
      </div>
    </div>
  );
}

// requireRole: role required to view the route. Defaults to "admin".
export const ProtectedRoute = ({ children, requireRole = "admin" }) => {
  const { user } = useAuth();
  if (user === undefined) return <Loader />;
  if (user === null) return <Navigate to="/admin/login" replace />;
  if (requireRole && user.role !== requireRole) return <AccessDenied />;
  return children;
};
